import { render, staticRenderFns } from "./admin-carousel-card.vue?vue&type=template&id=5069eed1&scoped=true&"
import script from "./admin-carousel-card.vue?vue&type=script&lang=js&"
export * from "./admin-carousel-card.vue?vue&type=script&lang=js&"
import style0 from "./admin-carousel-card.vue?vue&type=style&index=0&id=5069eed1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069eed1",
  null
  
)

export default component.exports